import * as React from "react";
import { DefaultVitalographLogo } from "../Core/VitalographLogo";
import { GuestFooter } from "../Guest/GuestFooter";

export const LockedOut = () => {
    return (
        <div className="middle-box text-center animated fadeInDown">
            <div>
                <div>

                    <h1 className="logo-name">
                        <img src={`data:image/png;base64,${DefaultVitalographLogo}`} alt="Vitalograph Logo" />
                    </h1>

                </div>
                <h3>Account Locked Out</h3>
                <p>
                    Your account is locked out.
                </p>

                <GuestFooter />
            </div>
        </div>
    )
}
